import {api, ContentType} from '../../api';
import {createMutation} from '../../lib';

const {postImportsExcelApprove} = api.imports;

export const usePostImportsExcelApprove = createMutation((params: Parameters<typeof postImportsExcelApprove>) => {
  const [data, query, reqParams] = params;
  return postImportsExcelApprove(data, query, {
    type: ContentType.FormData,
    ...reqParams,
  });
});
